import React from 'react';
import { motion } from 'framer-motion';

const NetworkVisual = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-20">
      <svg className="w-full h-full" viewBox="0 0 800 800">
        <defs>
          <radialGradient id="dotGradient" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#3B82F6" stopOpacity="1" />
            <stop offset="100%" stopColor="#3B82F6" stopOpacity="0" />
          </radialGradient>
        </defs>
        
        {/* Animated Grid Dots */}
        {[...Array(100)].map((_, i) => {
          const x = (i % 10) * 80 + 40;
          const y = Math.floor(i / 10) * 80 + 40;
          return (
            <motion.circle
              key={i}
              cx={x}
              cy={y}
              r="1.5"
              fill="url(#dotGradient)"
              animate={{
                opacity: [0.2, 0.5, 0.2],
                scale: [1, 1.5, 1],
              }}
              transition={{
                duration: 3 + Math.random() * 2,
                repeat: Infinity,
                delay: Math.random() * 2,
              }}
            />
          );
        })}

        {/* Floating Connection Lines */}
        {[...Array(15)].map((_, i) => (
          <motion.line
            key={i}
            x1={Math.random() * 800}
            y1={Math.random() * 800}
            x2={Math.random() * 800}
            y2={Math.random() * 800}
            stroke="#3B82F6"
            strokeWidth="0.5"
            strokeDasharray="4 4"
            animate={{
              strokeDashoffset: [0, -20],
              opacity: [0, 0.3, 0],
            }}
            transition={{
              duration: 5 + Math.random() * 5,
              repeat: Infinity,
              ease: "linear",
            }}
          />
        ))}
      </svg>
    </div>
  );
};

export default NetworkVisual;